
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { all_routes } from '../router/all_routes';
import AOS from 'aos';

const PrivacyPolicy = () => {
  const routes = all_routes;

  useEffect(() => {
    AOS.init({ duration: 1200, once: true });
  }, []);

  return (
    <div className="main-wrapper">
      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title">Politica de Confidențialitate</h2>
              <nav aria-label="breadcrumb" className="page-breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item"><Link to={routes.home}>Acasă</Link></li>
                  <li className="breadcrumb-item active" aria-current="page">Politica de Confidențialitate</li>
                </ol>
              </nav>
            </div>
          </div>
        </div>
      </div>

      <section className="section-modern" style={{ padding: '60px 0' }}>
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div 
                className="privacy-content" 
                style={{ background: '#fff', padding: '40px', borderRadius: '15px', boxShadow: '0 5px 20px rgba(0,0,0,0.05)' }}
                data-aos="fade-up"
              >
                <div className="privacy-header mb-5">
                  <h3 className="mb-3">1. Cine suntem</h3>
                  <p>
                    Confidențialitatea datelor dumneavoastră este importantă pentru noi. Această politică descrie modul în care <strong>AD SHOWROOM S.R.L.</strong> (denumită în continuare "AD SHOWROOM"), în calitate de <strong>Operator de date</strong>, prelucrează datele dumneavoastră cu caracter personal.
                  </p>
                  <p>
                    <strong>Date Operator:</strong><br/>
                    Sediul social: [ADRESA URL]<br/>
                    CUI: [ROXXXXXX]<br/>
                    Nr. Reg. Com: [JXX/XXXX/XXXX]
                  </p>
                </div>

                <div className="privacy-text mb-5">
                  <h3 className="mb-3">2. Ce date colectăm și de ce</h3>
                  <table className="table table-bordered">
                    <thead>
                        <tr>
                            <th>Scopul Prelucrării</th>
                            <th>Tipuri de Date Colectate</th>
                            <th>Temeiul Legal</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td><strong>Procesarea cererilor "Mașină pe comandă"</strong></td>
                            <td>Nume, telefon, email, preferințe auto, buget</td>
                            <td>Executarea unui contract / demersuri la cererea persoanei vizate</td>
                        </tr>
                        <tr>
                            <td><strong>Facturare și Contractare</strong></td>
                            <td>Nume/Denumire, Adresă, CNP/CUI, Cont Bancar</td>
                            <td>Obligație legală (Fiscală)</td>
                        </tr>
                        <tr>
                            <td><strong>Marketing (Newsletter)</strong></td>
                            <td>Adresa de email</td>
                            <td>Consimțământ (poate fi retras oricând)</td>
                        </tr>
                        <tr>
                            <td><strong>Programări Test Drive / Vizionare</strong></td>
                            <td>Nume, telefon, data preferată</td>
                            <td>Interes legitim (organizarea activității)</td>
                        </tr>
                    </tbody>
                  </table>
                </div>

                <div className="privacy-text mb-5">
                    <h3 className="mb-3">3. Cui dezvăluim datele</h3>
                    <p>Nu vindem datele dumneavoastră. Putem transmite datele către:</p>
                    <ul>
                        <li>Furnizori de servicii IT (hosting, mentenanță site).</li>
                        <li>Procesatori de plăți și Bănci.</li>
                        <li>Autorități publice (ANAF, Poliție), dacă există o obligație legală.</li>
                        <li>Firme de curierat/transport (pentru livrarea documentelor/mașinii).</li>
                    </ul>
                </div>

                <div className="privacy-text mb-5">
                  <h3 className="mb-3">4. Durata de păstrare</h3>
                  <ul>
                      <li>Datele de facturare: <strong>10 ani</strong> (conform Codului Fiscal).</li>
                      <li>Cererile de ofertă care nu se concretizează: <strong>12 luni</strong> (pentru istoric comercial), apoi sunt anonimizate sau șterse.</li>
                      <li>Datele de marketing: Până la retragerea consimțământului (dezabonare).</li>
                  </ul>
                </div>

                <div className="privacy-text mb-5">
                  <h3 className="mb-3">5. Drepturile Dumneavoastră GDPR</h3>
                  <p>Beneficiați de următoarele drepturi:</p>
                  <ul>
                      <li><strong>Dreptul de acces:</strong> să aflați dacă prelucrăm datele dvs. și să primiți o copie.</li>
                      <li><strong>Dreptul la rectificare:</strong> să corectați datele inexacte.</li>
                      <li><strong>Dreptul la ștergere ("dreptul de a fi uitat"):</strong> în anumite condiții.</li>
                      <li><strong>Dreptul la restricționare:</strong> puteți cere suspendarea prelucrării.</li>
                      <li><strong>Dreptul la portabilitate:</strong> să primiți datele într-un format structurat.</li>
                      <li><strong>Dreptul de opoziție:</strong> inclusiv la marketing direct.</li>
                  </ul>
                  <p>
                    Pentru a exercita aceste drepturi, ne puteți contacta la <strong>adcarshowroom@gmail.com</strong> sau prin poștă la sediul nostru.
                  </p>
                </div>
                
                <div className="privacy-footer mt-5 pt-4 border-top">
                  <p>
                      De asemenea, aveți dreptul de a depune o plângere la autoritatea de supraveghere: <a href="https://www.dataprotection.ro/" target="_blank">ANSPDCP (www.dataprotection.ro)</a>.
                  </p>
                  <p className="text-muted mb-0">
                    Ultima actualizare: 25 Ianuarie 2026
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
